export default __webpack_public_path__ + "static/media/pool.1ab2264b.svg";